import Api from "@/repository/api";
import {ResponseDataType} from "@/form/form.types";
import {CurrencyResponseType, ICurrency} from "@/entity/currency/currency.types";
import Currency from "@/entity/currency/currency";
import {ICurrencyRepository} from "@/repository/currency/СurrencyRepository.types";

export class CurrencyRepository implements ICurrencyRepository {
    async fetchAll(): Promise<ICurrency[]> {
        const resp = await Api.get('/currency/get');
        const respData = resp.data as CurrencyResponseType[];
        return respData.map((currency: CurrencyResponseType) => new Currency(currency));
    }
    async delete(data: { id: number }): Promise<ResponseDataType> {
        const resp = await Api.post('/currency/delete', data);
        return resp.data;
    }
}